"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _antd = require("antd");

var _Icon = _interopRequireDefault(require("../Icon"));

var _StretchList = require("./StretchList.style");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr && (typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]); if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

/**
 * 可伸展的列表內含checkbox功能呦
 */
var CheckGroup = _antd.Checkbox.Group;
var Panel = _antd.Collapse.Panel;

var noop = function noop() {};

var StretchList = function StretchList(_ref) {
  var _ref$title = _ref.title,
      title = _ref$title === void 0 ? "" : _ref$title,
      _ref$data = _ref.data,
      data = _ref$data === void 0 ? [] : _ref$data,
      _ref$checkedList = _ref.checkedList,
      checkedList = _ref$checkedList === void 0 ? [] : _ref$checkedList,
      _ref$isCheckType = _ref.isCheckType,
      isCheckType = _ref$isCheckType === void 0 ? true : _ref$isCheckType,
      _ref$onChange = _ref.onChange,
      onChange = _ref$onChange === void 0 ? noop : _ref$onChange,
      className = _ref.className,
      mt = _ref.mt,
      mb = _ref.mb,
      _ref$onClick = _ref.onClick,
      onClick = _ref$onClick === void 0 ? noop : _ref$onClick;

  var _useState = (0, _react.useState)(false),
      _useState2 = _slicedToArray(_useState, 2),
      indeterminate = _useState2[0],
      setIndeterminate = _useState2[1];

  var _useState3 = (0, _react.useState)(false),
      _useState4 = _slicedToArray(_useState3, 2),
      checkAll = _useState4[0],
      setCheckAll = _useState4[1];

  var onChangeHandle = function onChangeHandle(list) {
    onChange(list);
    onClick.apply(void 0, _toConsumableArray(list));
    setIndeterminate(!!list.length && list.length < data.length);
    setCheckAll(list.length === data.length);
  };

  var onCheckAllChangeHandle = function onCheckAllChangeHandle(e) {
    var list = e.target.checked ? data.map(function (item) {
      return item.value;
    }) : [];
    onChange(list);
    onClick.apply(void 0, _toConsumableArray(list));
    setIndeterminate(false);
    setCheckAll(e.target.checked);
  };

  var renderIcon = function renderIcon(isActive) {
    return /*#__PURE__*/_react.default.createElement(_Icon.default, {
      name: "arrow_drop_up",
      rotate: isActive ? 0 : 180,
      color: "#1890ff"
    });
  };

  (0, _react.useEffect)(function () {
    if (checkedList.length === 0) {
      setIndeterminate(false);
      setCheckAll(false);
    } else {
      setIndeterminate(!!checkedList.length && checkedList.length < data.length);
      setCheckAll(checkedList.length === data.length);
    }
  }, [checkedList]);
  return /*#__PURE__*/_react.default.createElement(_StretchList.UiStretchBox, {
    className: className,
    mt: mt,
    mb: mb
  }, /*#__PURE__*/_react.default.createElement(_antd.Collapse, {
    expandIcon: function expandIcon(_ref2) {
      var isActive = _ref2.isActive;
      return renderIcon(isActive);
    }
  }, /*#__PURE__*/_react.default.createElement(Panel, {
    key: "1",
    header: /*#__PURE__*/_react.default.createElement(_StretchList.UiStretchTitle, null, isCheckType && /*#__PURE__*/_react.default.createElement(_antd.Checkbox, {
      indeterminate: indeterminate,
      onChange: onCheckAllChangeHandle,
      checked: checkAll,
      onClick: function onClick(e) {
        e.stopPropagation();
      }
    }), title)
  }, /*#__PURE__*/_react.default.createElement(CheckGroup, {
    value: checkedList,
    onChange: onChangeHandle
  }, data.length > 0 && data.map(function (item, index) {
    return /*#__PURE__*/_react.default.createElement(_StretchList.UiStretchItem, {
      key: index
    }, isCheckType ? /*#__PURE__*/_react.default.createElement(_antd.Checkbox, {
      value: item.value
    }, item.label) : /*#__PURE__*/_react.default.createElement("span", null, item.label));
  })))));
};

var _default = StretchList;
exports.default = _default;
StretchList.propTypes = {
  title: _propTypes.default.string,
  code: _propTypes.default.string,
  data: _propTypes.default.arrayOf(_propTypes.default.shape({
    label: _propTypes.default.string,
    value: _propTypes.default.any
  })).isRequired,
  isCheckType: _propTypes.default.bool,
  checkedList: _propTypes.default.array,
  onChange: _propTypes.default.func,
  onClick: _propTypes.default.func,
  className: _propTypes.default.string,
  mt: _propTypes.default.string,
  mb: _propTypes.default.string
};